module.exports = __webpack_public_path__ + "static/media/0021.5bd314ea.png";